import type {
  EnrichmentLocale,
  LocaleMap,
  LocalizedText,
} from "@app/shared/models/enrichment-detail.model";

/** Apply `fn` to every non-null locale value of a LocalizedText, returning a
 *  LocaleMap. A plain-string input collapses to a single `en-US` slot; null /
 *  undefined → `{}`. Null locale values pass through untouched. */
function mapLocaleValues(
  v: LocalizedText,
  fn: (s: string) => string,
): LocaleMap {
  if (v == null) return {};
  if (typeof v === "string") return { "en-US": fn(v) };
  const out: LocaleMap = {};
  (Object.keys(v) as EnrichmentLocale[]).forEach((loc) => {
    const val = v[loc];
    out[loc] = val == null ? val : fn(val);
  });
  return out;
}

/** Wire "|" line breaks → textarea newlines (read path). */
export const pipesToNewlines = (v: LocalizedText): LocaleMap =>
  mapLocaleValues(v, (s) => s.split("|").join("\n"));

/** Textarea newlines → wire "|" line breaks (write path). */
export const newlinesToPipes = (v: LocaleMap): LocaleMap =>
  mapLocaleValues(v, (s) => s.split("\n").join("|"));
